import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RESPONSE } from 'src/express.tokens';
import { routes } from 'utils/routes';

const redirectToTripsProfile = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const response = isPlatformServer(platformId) ? inject(RESPONSE) : null;

  const lang = (route.params['lang'] ?? route.parent?.params['lang'] ?? 'it') as 'it' | 'en' | 'es' | 'fr' | 'de';
  const profileRoute = routes[lang]?.['routes.profile'];
  if (!profileRoute) return router.parseUrl('/not-found');

  const targetUrl = `/${lang}/${profileRoute}/${environment.tripsProfileSlug}`;

  if (isPlatformServer(platformId) && response) {
    response.redirect(301, targetUrl);
    response.end();
    return false;
  }

  return router.parseUrl(targetUrl);
};

export const tripRedirectGuard: CanActivateFn = route => redirectToTripsProfile(route);

export const tripsSearchRedirectGuard: CanActivateFn = route =>
  route.queryParams['value'] === 'sharrytravels' ? redirectToTripsProfile(route) : true;
